import { useEffect } from "react";
import { useUser } from "@jti/rip";
import { useConfig } from "@jti/ui";
export const useRedirectOnTradeIn = (isTradeIn) => {
    const config = useConfig();
    const { isLoggedIn } = useUser();
    useEffect(() => {
        if (isTradeIn && isLoggedIn === false) {
            window.location.replace(`${config.AUTH_PAGE_URL}#/login?returnUrl=${window.location.pathname}`);
        }
    }, [config.AUTH_PAGE_URL, isLoggedIn, isTradeIn]);
};
//# sourceMappingURL=useRedirectOnTradeIn.js.map